// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dcf697f3","453":"5be4089a","455":"6242762b","507":"9cbe1db8","644":"27a2eeff"}[chunkId] + ".chunk.js";
};